import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, motion } from '../tokens';
import { quickActionIcon } from '../icons';

const DEFAULT_ACTIONS = ['log-gift', 'email', 'call', 'task', 'note', 'pledge'];

const QuickActionBar = ({
  actions = DEFAULT_ACTIONS,
  onAction,
  orientation = 'horizontal',
  size = 'md',
}) => {
  const isVertical = orientation === 'vertical';
  const btnPad = size === 'sm' ? `${space[1]}px ${space[2]}px` : `${space[2]}px ${space[3]}px`;
  const fontSize = size === 'sm' ? 12 : 13;

  return (
    <div style={{
      display: 'flex',
      flexDirection: isVertical ? 'column' : 'row',
      gap: space[2],
      flexWrap: isVertical ? 'nowrap' : 'wrap',
    }}>
      {actions.map((id) => {
        const cfg = quickActionIcon[id];
        if (!cfg) return null;
        return (
          <button
            key={id}
            onClick={() => onAction && onAction(id)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: space[2],
              padding: btnPad,
              background: colors.surface,
              border: `1px solid ${colors.border}`,
              borderRadius: radius.sm,
              ...type.small,
              fontWeight: 600,
              fontSize,
              color: colors.textPrimary,
              fontFamily: 'inherit',
              cursor: 'pointer',
              transition: `all ${motion.fast}`,
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = colors.brand;
              e.currentTarget.style.color = colors.brand;
              e.currentTarget.style.background = colors.brandMuted;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = colors.border;
              e.currentTarget.style.color = colors.textPrimary;
              e.currentTarget.style.background = colors.surface;
            }}
          >
            <Icon category="utility" name={cfg.name} size="x-small" style={{ fill: 'currentColor' }} />
            {cfg.label}
          </button>
        );
      })}
    </div>
  );
};

export default QuickActionBar;
